import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

type Props = {
  fullscreen?: boolean;
  title?: string | undefined | null;
  subTitle?: string | undefined | null;
  centered?: boolean;
};

export default function LoadingModal({ title, subTitle, fullscreen, centered }: Props) {
  return (
    <Modal isOpen={true} unmountOnClose={true} fullscreen={fullscreen} centered={centered}>
      <ModalBody className="d-flex items-center justify-content-center flex-column">
        <div>
          <img src={require('@/assets/loading.gif')} style={{ height: 100 }} alt="loading" />
        </div>
        {title ? <div className="fw-500 text-22 mt-5 text-dark-1">{title}</div> : null}
        {subTitle ? <div className="mt-5 text-16 text-dark-1">{subTitle}</div> : null}
      </ModalBody>
    </Modal>
  );
}
